import React, { Component } from 'react';
import {
    Col, Row, Card, CardBody, Button, Collapse, Alert
} from 'reactstrap';
import '@nosferatu500/react-sortable-tree/style.css';
import EndUserDetails from './EndUserForm/index';
import CompanyDetails from './Form/index';
import WhitelabelDetails from './WhitelabelForm/index';
import SecurityDetails from './SecurityForm/index';
import { connect } from 'react-redux';
import {
    setCorporateOnboardingStatus, getStatesList, setCompanySetup, getEditData,
    setProductSetup, saveScorecardData, setCreditSetup
} from '../action';
import { getCorporateName } from '../../../../Analyst/Cases/List/Actions';
import SortableTree from '@nosferatu500/react-sortable-tree';
import './style.scss';
import Modal from '../../../../components/UI/Modal/Modal'
import { Preloading } from '../../../../components/UI/Preloader/action';
import { setPageView } from '../../../../components/GoogleAnalytics/index';
import { addNode, generateNewCompanyData, convertRowInfo, convertApiData, findNode, addUserInNode, deleteUserInNode, deleteCompanyDetailsInNode, setWhiteLabelData, convertApiDataForSecurityDetails } from './helper';
import AddDefaultProducts from './AddDefaultProducts';
const { v1: uuidv1 } = require('uuid');

class CreateCorporateComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandCorporateDetails: false,
            expandUserDetails: false,
            expandWhitelabelDetails: false,
            expandSecurityDetails: false,
            showRadioButtons: false,
            stateList: [],
            treeData: [],
            nodeKeyInAction: '',
            userList: [],
            rootNodeKey: '',
            initialUserDetailsValue: {},
            initialCompanyDetailsValue: {},
            initialSecurityDetailsValue: {},
            deletedUserDetails: [],
            detetedCompanyNameDetails: [],
            updateFlag: false,
            nodeObjSelected: {},
            showUserModal: false,
            companyData: [],
            purgeDuration:0,
            whitelabelData: {
                corporateLogo: null,
                corporateColor: null
            },
            userDeletePopUp: <div>
                <div>This will remove the user and all his access from Rubix platform. Do you want to continue?</div>
                <div>
                    <Button color="primary" className="mr-1 mt-3" onClick={(event) => this.deleteUserDetailsCallback(event)} >OK</Button>
                    <Button color="secondary" className="mr-1 mt-3" onClick={(event) => this.cancelDeleteUserDetailsCallback(event)}>Cancel</Button>
                </div>
            </div>,
            companyDeletePopUP: <div>
                <div>This will remove the company/subsidiary/division and all mapped users along with its (sub)subsidiaries/(sub)divisions (if any). Do you want to continue?</div>
                <div>
                    <Button color="primary" className="mr-1 mt-3" onClick={(event) => this.deleteCompanyNameDetails(event)}>OK</Button>
                    <Button color="secondary" className="mr-1 mt-3" onClick={(event) => this.cancelDeleteCompanyNameDetails(event)}>Cancel</Button>
                </div>
            </div>,
            showCompanyModal: false,
            userKeyInAction: "",
            errorMsg: "",
            showAddDefaultProductsModal: false,
            corpIdNameMap: new Map(),
            nameCorpIdMap: new Map()
        };
    }


    saveEndUsers = (event, obj, userUpdateFlag) => {
        if (!userUpdateFlag) {
            obj.id = 'js_' + uuidv1();
        }
        let userlist = {};
        let newTreeData = Object.assign([], this.state.treeData);
        if (newTreeData.length > 0) {
            addUserInNode(newTreeData, obj, userlist, this.state.nodeKeyInAction);
        }
        this.extractAllUserDetailsFromTreeData(newTreeData);
        this.setState({
            treeData: newTreeData,
            userList: userlist.result,
            initialUserDetailsValue: userlist.initialUserDetailsValue
        })
        event.preventDefault();
    }



    goToProductSetup = (event) => {
        if (document.getElementsByClassName("validationClass")[0] == null) {
            if (this.state.treeData.length > 0) {
                if (this.state.treeData[0].userDetails && this.state.treeData[0].userDetails.length > 0) {
                    this.setState({
                        errorMsg: '',
                    })
                    let data = {
                        corporate: this.state.treeData,
                        detetedCompanyNameDetails: this.state.detetedCompanyNameDetails,
                        deletedUserDetails: this.state.deletedUserDetails
                    }
                    this.props.setCompanySetup(data);
                    this.props.history.push('../productsetup');
                    this.props.activeCompanyProgressTab('setup-progress-element finished')
                }
                else {
                    this.setState({
                        errorMsg: 'Please Add users in your parent company',
                    })
                }
            }

        }
        else {
            this.setState({
                errorMsg: 'Please fill details of all added companies/subsidiaries/divisions',
            })
        }
        event.preventDefault();
    }

    componentDidMount(prevProps) {
        // Check if states list is already present
        setPageView('/Admin/create/corporate', document.location.href)
        if (!this.props.getStatesListData) {
            this.props.getStatesList();
        }
        else {
            this.setState({
                stateList: this.props.getStatesListData.data,
            })
        }

        // case of EDIT
        if (this.props.match.params.corporateId) {

            this.props.setCorporateOnboardingStatus(true);
            if (!this.props.companySetupData ||
                !this.props.companySetupData.corporate ||
                this.props.companySetupData.corporate.length === 0) {// || this.props.companySetupData.corporateId) {
                // Load company edit data
                this.props.getEditData(this.props.match.params.corporateId);
                this.props.activeEditCompanyProgressTab('setup-progress-element current')
                this.props.preloading(true)
            }
            else {
                // If user is navigating between company setup <--> Product setup <--> Scorecard setup, then just prefill the company data with already loaded data
                if (this.props.match.params.corporateId === this.props.companySetupData.corporate[0].id) {
                    let data = Object.assign([], this.props.companySetupData.corporate);
                    this.extractAllUserDetailsFromTreeData(data);
                    this.setState({
                        treeData: data,
                        detetedCompanyNameDetails: [],
                        deletedUserDetails: [],
                        expandCorporateDetails: false,
                        expandUserDetails: false,
                        rootNodeKey: data[0].id,
                        nodeKeyInAction: data[0].id,
                        userList: data[0].userDetails,
                        initialCompanyDetailsValue: data[0]
                    })
                    this.showCompanyDetails(data[0]);
                }
                // If user is coming from somewhere else; Direct url writing or Corporate list > Edit, then load the edit data afresh
                else {
                    // Load company edit data
                    this.props.preloading(true)
                    this.props.getEditData(this.props.match.params.corporateId);
                    this.props.activeEditCompanyProgressTab('setup-progress-element current')
                }
            }
        }
        // case of ??????
        else if (this.props.companySetupData && this.props.companySetupData.corporate) {
            let data = [];
            if (!Array.isArray(this.props.companySetupData.corporate)) {
                data.push(this.props.companySetupData.corporate)
            }
            else if (this.props.editStatus === true) {
                data.push(generateNewCompanyData());
                this.props.setProductSetup([]);
                this.props.saveScorecardData([]);
                this.props.setCreditSetup("")
            }
            else {
                data = this.props.companySetupData.corporate
            }
            this.extractAllUserDetailsFromTreeData(data);
            this.setState({
                treeData: data,
                detetedCompanyNameDetails: this.props.companySetupData.detetedCompanyNameDetails,
                deletedUserDetails: this.props.companySetupData.deletedUserDetails,
                expandCorporateDetails: false,
                expandUserDetails: false,
                rootNodeKey: data[0].id,
                nodeKeyInAction: data[0].id,
                userList: data[0].userDetails,
                initialCompanyDetailsValue: data[0]
            })
            this.showCompanyDetails(data[0]);
            this.props.setCorporateOnboardingStatus(false);
        }
        // case of CREATE
        else {
            this.props.setCorporateOnboardingStatus(false);
            let data = [];
            data.push(generateNewCompanyData());
            this.extractAllUserDetailsFromTreeData(data);
            this.setState({
                treeData: data,
                detetedCompanyNameDetails: [],
                deletedUserDetails: [],
                expandCorporateDetails: true,
                expandUserDetails: false,
                rootNodeKey: data[0].id,
                nodeKeyInAction: data[0].id,
                nodeObjSelected: data[0],
                userList: data[0].userDetails
            })
            this.props.activeCompanyProgressTab('setup-progress-element current')
        }

    }

    extractAllUserDetailsFromTreeData = (treeData) => {
        let corpIdNameMap = new Map();
        this.extractDetailsFromNode(treeData[0], corpIdNameMap);
        let nameCorpIdMap = this.reverseKeyToValueOfMap(corpIdNameMap);
        this.setState({
            corpIdNameMap: corpIdNameMap,
            nameCorpIdMap: nameCorpIdMap
        })
    }

    extractDetailsFromNode = (node, corpIdNameMap) => {
        corpIdNameMap.set(node.id, node.name)
        if(node.children && node.children.length > 0) {
            for(let child of node.children)
                this.extractDetailsFromNode(child, corpIdNameMap);
        }
    }

    reverseKeyToValueOfMap = (originalMap) => {
        let reversedMap = new Map();
        for (const [key, value] of originalMap)
            reversedMap.set(value, key);
        return reversedMap;
    }

    toggleCorporateDetails = () => {
        this.setState((prevState) => ({
            expandCorporateDetails: !prevState.expandCorporateDetails,
            expandUserDetails: false,
            expandWhitelabelDetails: false,
            expandSecurityDetails: false
        }));
    }

    toggleSecurityDetails = () => {
        this.setState((prevState) => ({
            expandUserDetails: false,
            expandCorporateDetails: false,
            expandWhitelabelDetails: false,
            expandSecurityDetails: !prevState.expandSecurityDetails
        }));
    }

   

    toggleUserDetails = () => {
        this.setState((prevState) => ({
            expandUserDetails: !prevState.expandUserDetails,
            expandCorporateDetails: false,
            expandWhitelabelDetails: false
        }));
    }
    toggleWhitelabelDetails = () => {
        this.setState((prevState) => ({
            expandUserDetails: false,
            expandCorporateDetails: false,
            expandWhitelabelDetails: !prevState.expandWhitelabelDetails
        }));
    }
    companyNameDetails = (e, companyFormValues, updateFlagOnSave) => {
        if (this.state.nodeKeyInAction !== "") {
            // Update tree ui
            let newTreeData = Object.assign([], this.state.treeData);
            let data = convertApiData(companyFormValues);
            data.id = this.state.nodeKeyInAction;
            findNode(newTreeData, data, this.state.nodeKeyInAction);
            this.setState({
                treeData: newTreeData,
                expandCorporateDetails: false,
                expandUserDetails: true,
                nodeObjSelected: data,
                errorMsg: ""
            })
        }
        else {
            this.setState({
                errorMsg: 'Please Select a Company Node First',
            })
        }
        e.preventDefault();
    }

    hanldeSecurityDetailsSave = (e,purgeDataValues)=>{
        let newTreeData = Object.assign([], this.state.treeData);
        let data =  convertApiData(purgeDataValues);
        console.log("test is ",data);
        data.id = this.state.nodeKeyInAction;
        findNode(newTreeData, data, this.state.nodeKeyInAction);
        this.setState({
            treeData: newTreeData,
            expandCorporateDetails: false,
            expandUserDetails: false,
            expandSecurityDetails: false,
            nodeObjSelected: data,
            purgeDuration:purgeDataValues['purgeDuration'],
            errorMsg: ""
        })

    }

    componentDidUpdate(prevProps) {
        // case of CREATE
        if (!this.props.match.params.corporateId) {
            if (this.props.match.params.corporateId !== prevProps.match.params.corporateId) {
                this.props.setCompanySetup(null);
                this.props.setProductSetup([]);
                this.props.saveScorecardData([]);
                this.props.setCreditSetup("")
                let data = [];
                data.push(generateNewCompanyData());
                this.extractAllUserDetailsFromTreeData(data);
                this.setState({
                    treeData: data,
                    detetedCompanyNameDetails: [],
                    deletedUserDetails: [],
                    expandCorporateDetails: true,
                    expandUserDetails: false,
                    rootNodeKey: data[0].id,
                    nodeKeyInAction: data[0].id,
                    nodeObjSelected: data[0],
                    userList: data[0].userDetails,
                    initialCompanyDetailsValue: {}
                })
                this.props.activeCompanyProgressTab('setup-progress-element current')
            }
            else if (this.props.editStatus === true && this.props.editStatus !== prevProps.editStatus) {
                this.props.setCompanySetup(null);
                this.props.setProductSetup([]);
                this.props.saveScorecardData([]);
                this.props.setCreditSetup("")
                let data = [];
                data.push(generateNewCompanyData());
                this.extractAllUserDetailsFromTreeData(data);
                this.setState({
                    treeData: data,
                    detetedCompanyNameDetails: [],
                    deletedUserDetails: [],
                    expandCorporateDetails: true,
                    expandUserDetails: false,
                    rootNodeKey: data[0].id,
                    nodeKeyInAction: data[0].id,
                    nodeObjSelected: data[0],
                    userList: data[0].userDetails
                })
                this.props.activeCompanyProgressTab('setup-progress-element current')
            }
        }
        // else{

        // }
        if (this.props.getStatesListData !== prevProps.getStatesListData) {
            this.setState({
                stateList: this.props.getStatesListData.data,
            })
        }
        // case of EDIT
        if (this.props.editData !== prevProps.editData) {
            let editableCompanySetupData = {};
            editableCompanySetupData.deletedCompanyDetails = this.props.editData.data.corporateDetails.deletedCompanyDetails;
            editableCompanySetupData.deletedUserDetails = this.props.editData.data.corporateDetails.deletedUserDetails;
            editableCompanySetupData.corporate = [this.props.editData.data.corporateDetails.corporate];
            this.props.setCompanySetup(editableCompanySetupData);
            this.props.setProductSetup(this.props.editData.data.productList);
            this.props.saveScorecardData(this.props.editData.data.scorecardList);
            // this.props.setCreditSetup(this.props.editData.data.credits)
            let data = [];
            data.push(this.props.editData.data.corporateDetails.corporate);
            this.extractAllUserDetailsFromTreeData(data);

            this.setState({
                treeData: data,
                detetedCompanyNameDetails: [],
                deletedUserDetails: [],
                expandCorporateDetails: false,
                expandUserDetails: false,
                rootNodeKey: data[0].id,
                nodeKeyInAction: data[0].id,
                errorMsg: ""
            })
            this.showCompanyDetails(this.props.editData.data.corporateDetails.corporate);
            this.showSecurityDetails(this.props.editData.data.corporateDetails.corporate);
        }
        if (this.props.editDataError !== prevProps.editDataError) {
            this.setState({
                errorMsg: (this.props.editDataError.response && this.props.editDataError.response.data) ? this.props.editDataError.response.data.message : "Something went wrong! Please try again."
            })
        }
    }

    showCompanyDetails = (companyData) => {
        let data = convertRowInfo(companyData);
        let isRootNode = false;
        if (data.id === this.state.rootNodeKey) {
            isRootNode = true;
        }
        this.setState({
            companyData: companyData,
            expandCorporateDetails: true,
            expandUserDetails: false,
            nodeKeyInAction: data.id,
            updateFlagOnSave: true,
            nodeSelected: data.id,
            showRadioButtons: !isRootNode,
            userList: companyData.userDetails,
            initialCompanyDetailsValue: data,
            whitelabelData: {
                corporateLogo: companyData.logoBase64,
                corporateColor: companyData.colorHexCode
            }
        })
    }

    showSecurityDetails = (securityData) => {
        let data = convertRowInfo(securityData);
        this.setState({
            initialSecurityDetailsValue: data,
        })
    }

    addCompanyDetails = (id) => {
        let newTreeData = Object.assign([], this.state.treeData);
        let newNode = addNode(newTreeData, id);
        this.setState({
            treeData: newTreeData,
        });
        this.showCompanyDetails(newNode);


    }

    showEndUserDetails = (rowInfo) => {
        let data = convertRowInfo(rowInfo.node);
        let { node } = rowInfo;
        let flag = true;
        if (data.id === this.state.rootNodeKey) {
            flag = false
        }
        this.setState({
            nodeKeyInAction: node.id,
            expandUserDetails: true,
            expandCorporateDetails: false,
            userList: node.userDetails,
            initialCompanyDetailsValue: data,
            purgeDuration: 0,
            showRadioButtons: flag,
        })
    }

    loadUserDetailsCallback = (event, obj) => {
        this.setState({
            initialUserDetailsValue: obj
        })
        event.preventDefault();
    }

    resetEndUserDetailsCallback = (event) => {
        this.setState({
            initialUserDetailsValue: {}
        })
        event.preventDefault();
    }

    deleteUserDetailsCallback = (event) => {
        event.preventDefault();
        let data = {}
        let newTreeData = Object.assign([], this.state.treeData);
        deleteUserInNode(newTreeData, this.state.userKeyInAction, data, this.state.nodeKeyInAction);
        let deletedUserDetails = Object.assign([], this.state.deletedUserDetails);
        deletedUserDetails.push(this.state.userKeyInAction);
        this.setState(prevState => ({
            treeData: newTreeData,
            userList: data.userList,
            deletedUserDetails: deletedUserDetails,
            updateFlag: !prevState.updateFlag,
            showUserModal: false
        }))
    }



    deleteCompanyNameDetails = (event) => {
        event.preventDefault();
        let newTreeData = Object.assign([], this.state.treeData);
        let deletedCompanyDetailsFlagObject = {}
        let parentNodeOfDeletedNode = deleteCompanyDetailsInNode(newTreeData, null, this.state.nodeKeyInAction, deletedCompanyDetailsFlagObject);

        let detetedCompanyNameDetails = Object.assign([], this.state.detetedCompanyNameDetails);
        if (deletedCompanyDetailsFlagObject.addFlagInArray) {
            detetedCompanyNameDetails.push(this.state.nodeKeyInAction);
        }
        this.setState(prevState => ({
            treeData: newTreeData,
            nodeKeyInAction: "",
            detetedCompanyNameDetails: detetedCompanyNameDetails,
            showCompanyModal: false
        }))
        this.showCompanyDetails(parentNodeOfDeletedNode);
    }

    deleteCompanyNameDetailsData = (id) => {
        if (this.state.rootNodeKey === id) {
            this.setState({
                errorMsg: 'Cannot delete parent company!'
            });
            return;
        }
        this.setState({
            nodeKeyInAction: id,
            showCompanyModal: true
        });
    }

    cancelDeleteCompanyNameDetails = (event) => {
        event.preventDefault();
        this.setState(prevState => ({
            showCompanyModal: false
        }))
    }

    deleteUserDetailsCallbackSetData = (event, obj) => {
        event.preventDefault();
        this.setState(prevState => ({
            userKeyInAction: obj.id,
            showUserModal: true
        }))
    }

    cancelDeleteUserDetailsCallback = (event) => {
        event.preventDefault();
        this.setState(prevState => ({
            showUserModal: false
        }))
    }

    preventDroppingOnRootLevel = (obj) => {
        if (obj.nextParent == null) {
            return false;
        }
        else {
            return true;
        }
    }
    handleWhitelabelDetails = (data, flag) => {
        this.setState({
            whitelabelData: {
                corporateLogo: (data.corporateLogo) ? data.corporateLogo[0] : null,
                corporateColor: data.corporateColor
            },
            expandWhitelabelDetails: (flag) ? false : true
        });
        const tempTreeData = setWhiteLabelData(data, this.state.companyData, this.state.treeData)
        let newTreeData = Object.assign([], this.state.treeData);
        newTreeData = tempTreeData;
    }

    handleAddDefaultProducts = () => {
        this.setState(prevState => ({
            showAddDefaultProductsModal: !prevState.showAddDefaultProductsModal,
      }))
      }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3" >
                    <h5 className="mb-0">
                        Company Setup
                    </h5>
                </div>

                <Alert color="danger" isOpen={this.state.errorMsg ? true : false} toggle={() => { this.setState({ errorMsg: '' }) }}>
                    {this.state.errorMsg}
                </Alert>
                <Card className="pb-70">
                    <CardBody>
                        <Row>
                            <Col xs="15">
                                <div style={{ height: 600 }}>
                                    <SortableTree
                                        treeData={this.state.treeData}
                                        onChange={treeData => this.setState({ treeData })}
                                        canDrop={(event) => this.preventDroppingOnRootLevel(event)}
                                        generateNodeProps={(rowInfo) => ({
                                            buttons: [
                                                <div className={this.state.nodeKeyInAction === rowInfo.node.id ? "node d-flex position-relative selected" : "node d-flex position-relative"}>{/*Add class="selected" at this level when company/user is selected*/}
                                                    <div className="d-flex justify-content-between node-title-box">
                                                        <div className="title-name" onClick={() => this.showCompanyDetails(rowInfo.node, rowInfo)}>{rowInfo.node.name}</div>
                                                        <div className="user-count d-flex align-items-center"><i className="fa fa-group mr-2"></i> {rowInfo.node.userDetails.length}</div>
                                                    </div>
                                                    <div className="d-flex">
                                                        <Button color="primary" className="user-add ml-2 pl-3 pr-3 d-flex align-items-center" onClick={() => this.showEndUserDetails(rowInfo)} title="Add users to this company/subsidiary/division"><i className="fa fa-user-plus"></i></Button>
                                                        <Button color="primary" className="user-add ml-2 pl-3 pr-3" onClick={() => this.deleteCompanyNameDetailsData(rowInfo.node.id)} title="Delete this company/subsidiary/division"><i className="fa fa-trash"></i></Button>
                                                    </div>

                                                    <button type="button" className="add-company position-absolute" onClick={() => this.addCompanyDetails(rowInfo.node.id)}>
                                                        <i className="icon-plus position-absolute"></i>
                                                    </button>
                                                    {rowInfo.node.name === "" ? <i title="Please enter details of the company" className="validationClass fa fa-exclamation-circle" aria-hidden="true"></i> : null}
                                                </div>
                                            ],
                                            style: {
                                                height: '50px',
                                            }
                                        })}

                                    />
                                </div>
                            </Col>
                            <Col xs="9">
                                <article className="collapse-company-details mb-4">
                                    <div data-target="#collapse1" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={this.toggleCorporateDetails} >
                                        <h5>Company Details</h5>
                                        <i></i>
                                    </div>
                                    <Collapse id="collapse1" isOpen={this.state.expandCorporateDetails}>
                                        <CompanyDetails updateFlagOnSave={this.state.updateFlagOnSave}
                                            initialValues={this.state.initialCompanyDetailsValue}
                                            saveCompanyNameDetailsCallback={this.companyNameDetails}
                                            stateList={this.state.stateList}>
                                        </CompanyDetails>
                                    </Collapse>
                                </article>
                                <article className="collapse-company-details">
                                    <div data-target="#collapse2" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={this.toggleUserDetails} >
                                        <h5>End User(s) Details</h5>
                                        <i></i>
                                    </div>
                                    <Collapse id="collapse2" isOpen={this.state.expandUserDetails}>
                                        <EndUserDetails deleteUserDetailsCallback={this.deleteUserDetailsCallbackSetData} 
                                        resetEndUserDetailsCallback={this.resetEndUserDetailsCallback} 
                                        loadUserDetailsCallback={this.loadUserDetailsCallback} 
                                        initialValues={this.state.initialUserDetailsValue} manageActiveInactiveUser={this.manageActiveInactiveUser} 
                                        allUsers={this.state.userList} saveEndUserDetailsCallback={this.saveEndUsers} 
                                        saveTransferedUserData={this.saveTransferedUserData} inactiveUsers={this.state.inactiveUserList} 
                                        corporateNames={this.state.corporateNames} updateFlag={this.state.updateFlag} 
                                        treeData={this.state.treeData} corpIdNameMap={this.state.corpIdNameMap}
                                        nameCorpIdMap={this.state.nameCorpIdMap}>
                                        </EndUserDetails>
                                    </Collapse>
                                </article>
                                <article className="collapse-company-details">
                                    <div data-target="#collapse3" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={this.toggleWhitelabelDetails} >
                                        <h5>Whitelabel Details</h5>
                                        <i></i>
                                    </div>
                                    <Collapse id="collapse3" isOpen={this.state.expandWhitelabelDetails}>
                                        <WhitelabelDetails initialValues={this.state.whitelabelData} whitelabelCallback={this.handleWhitelabelDetails} />

                                    </Collapse>
                                </article>
                                <article className="collapse-company-details">
                                    <div data-target="#collapse4" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={this.toggleSecurityDetails} >
                                        <h5>Security Details</h5>
                                        <i></i>
                                    </div>
                                    <Collapse id="collapse4" isOpen={this.state.expandSecurityDetails}>
                                        <SecurityDetails 
                                            initialValues={this.state.initialSecurityDetailsValue}
                                            saveSecurityDetailsCallback = {this.hanldeSecurityDetailsSave}>
                                        </SecurityDetails>
                                             
                                    </Collapse>
                                </article>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <footer className="bg-light footer w-100 text-center">
                <Button color="primary" onClick={this.handleAddDefaultProducts} className = "mx-xl-5">
                <i className="fa fa-plus" aria-hidden="true"></i>&nbsp;&nbsp;Add Default Products
                    </Button>  
                    <Button color="primary" onClick={(event) => this.goToProductSetup(event)} className = "mx-xl-5">
                        Next
                        &nbsp;&nbsp;<i className="fa fa-angle-double-right"></i>
                    </Button>
                </footer>
                <Modal show={this.state.showUserModal} className='Modal' >
                    {this.state.userDeletePopUp}
                </Modal>
                <Modal show={this.state.showCompanyModal} className='Modal' >
                    {this.state.companyDeletePopUP}
                </Modal>
                <AddDefaultProducts showAddDefaultProductsModal = {this.state.showAddDefaultProductsModal} closeModal = {this.handleAddDefaultProducts} corporateId = {this.props.match.params.corporateId}/>
            </Col>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    getStatesListData: state.corporateOnBoardingCreate.statesListSuccessData,
    companySetupData: state.corporateOnBoardingCreate.companySetup,
    editData: state.corporateOnBoardingCreate.editData,
    editStatus: state.corporateOnBoardingCreate.corporateOnboardingStatus,
    editDataError: state.corporateOnBoardingCreate.editDataError
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    getStatesList: () => { dispatch(getStatesList()) },
    setCompanySetup: (data) => { dispatch(setCompanySetup(data)) },
    setCorporateOnboardingStatus: (data) => { dispatch(setCorporateOnboardingStatus(data)) },
    setProductSetup: (data) => { dispatch(setProductSetup(data)) },
    saveScorecardData: (data) => { dispatch(saveScorecardData(data)) },
    getEditData: (data) => { dispatch(getEditData(data)) },
    setCreditSetup: (data) => { dispatch(setCreditSetup(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});


export default CreateCorporateComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateCorporateComponent)


